import React, { lazy, Suspense } from "react";
import { createRoot } from "react-dom/client";

const Loader = ({ children }) => {
	const Loading = () => <div>Loading...</div>;
	return <Suspense fallback={<Loading />}>{children}</Suspense>;
};

const LazyComponents = {
	Calculator: lazy(() => import("./Calculator/index.jsx")),
	ResourceLibrary: lazy(() => import("./ResourceLibrary/index.jsx")),
	TruckSpecs: lazy(() => import("./ResourceLibrary/TruckSpecs.jsx"))
}

// adding an empty async export here to satisfy the current JS loader we have in place
export default async (element) => {
	const Component = LazyComponents[element?.dataset?.react];
	const props = JSON.parse(element?.dataset?.props || "{}");	
	if (Component) {
		const root = createRoot(element);
		root.render(<Loader>
			<React.StrictMode>
				<Component {...props} />
			</React.StrictMode>
		</Loader>);
	} else {
		console.warn(`Expected React component name but found: ${Component}`);
	}
};
